
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { mapGetters } from "vuex";

import { mdiArrowLeft, mdiArrowRight } from "@mdi/js";
import SpTestimonial from "~/components/v2/splash/sp-testimonial.vue";

export default {
  components: { VueSlickCarousel, SpTestimonial },
  data() {
    return {
      mdiArrowLeft,
      mdiArrowRight,

      settings: {
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        touchThreshold: 5,
        arrows: true,
        draggable: true,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: "24px",
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      discreetMode: "getDiscreetStatus",
      testimonials: "sliders/getTestimonials",
    }),
  },
  mounted() {
    setTimeout(() => {
      this.setSlidesHeight();
    }, 1000);
  },
  methods: {
    setSlidesHeight() {
      const slides = document.querySelectorAll(".sp-testimonial");
      const maxHeight = Math.max(
        ...Array.from(slides).map((slide) => slide.clientHeight)
      );

      Array.from(slides).forEach((slide) => {
        slide.style.height = `${maxHeight}px`;
      });
    },
  },
};
